module.exports = __webpack_public_path__ + "static/media/health-white.548bb7ba.svg";